import React, {Component} from "react";
import styled from "styled-components";
import { history } from "../utils";
import Gamification from './Gamification';
import { Flex, Link, Button } from "../components";
import Modal from "./LiveCodeModal";
import {VerifyLiveTestCode} from '../lib/api'
// import amplitude from 'amplitude-js/aplitude';
// // import Amplitude from 'react-amplitude';
// import moment from 'moment';


// amplitude.getInstance().init('b781fe374c11394b27e21b826356483c');

const TestDescriptionWrapper = styled.div`
  display: grid;
  grid-gap: 2rem;
  margin-bottom: 6rem;
  img {
    width: 100%;
  }
  @media (max-width: 768px) {
    grid-template-columns: auto;
  }
`;



function checkNative() {
  try {
    if ((window.webkit) || window.appInterface)
      return true;
    else return false;
  } catch (error) {
    console.log(error);
  }
}


// function logAmplitudeEvent(results) {
//   if (!results) {
//     let time_stamp = moment().format('YYYY-MM-DD hh:mm:ss').toString();
//     // Amplitude.logEventWithTimestamp('test started', null, time_stamp, null);
//     amplitude.getInstance().logEvent('started test 2016')
//   }
// }

class TestDescription extends Component {

    state = {
        showGamificaton: false,
        numbers: [1,2,3],
        currentNumber: 1  
    }
    constructor(props) {
        super(props);
        this.openModalRef = React.createRef();
    }  

  openModal = (tid, results, search) =>{
    this.openModalRef.current.openModalHandler()
  }

  startTest = (tid, results, search) =>{
    this.setState({showGamificaton: true})
    setTimeout(()=>{
      this.setState({showGamificaton: false})
      if (results) {
        history.push(`/liveTestResults/${tid}/0`)
      } else {
        history.push(`/liveTest/${tid}/0`)
      }
    },4200)   
  }

  submitCode = async (tid,code) =>{
    console.log(tid, code)
    let response = await VerifyLiveTestCode(tid, code)
    if (response.validation == 1) {
        console.log('validated')
        return 'true'
    } else{
        return 'false'
    }
      
  }

  callbackToNative = (msg) => {
    try {
      if (window.webkit != undefined) {
        window.webkit.messageHandlers.observe.postMessage(msg);
        window.webkit.messageHandlers.appInterface.postMessage(msg)
      }
      if (window.appInterface != undefined) {
        window.appInterface.postMessage(msg)
      }
    } catch (error) {
      console.log(msg);
      console(error);
    }
  }
  open =()=> {
      this.setState({open:true, })
  }
  render () {
    let { test_id, name, start_time, end_time, created_at, description, results } = this.props
    if(this.state.showGamificaton) {
      return <Gamification></Gamification>
    }
    return (
    <div style={{ padding: '20px' }}>
      <Flex column center>
          <Modal ref={this.openModalRef} submit = {this.submitCode} tid={test_id} results={results} startTest={this.startTest}></Modal>
        {name ?
          <div>
            <div style={{ position: 'fixed', top: '0', paddingTop: '20px', left: '20px', background: '#f6f6f6', width: '100%', cursor: 'pointer' }}>
              <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
            </div>
            <h1 style={{ margin: '0.3em 0', fontSize: '28px', textAlign: 'center', marginTop:'30px' }}>{name}</h1>
            <TestDescriptionWrapper>
              {/* {test_img &&
            <img
              src={test_img}
              alt=""
            />
          } */}
              <Flex column>
                <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Description</h3>
                <p>{description}</p>
                {/* <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Duration of the test</h3>
                <p>{expiryTime < timelimit ? (parseFloat(expiryTime).toFixed() / 60).toFixed() : parseFloat(timelimit).toFixed() / 60} minutes</p> */}
                <div>
                  <h3 style={{ fontSize: '20px', margin: '0.3em 0' }}>Instructions:</h3>
                  <ul>
                  <li>
                    <b>Make sure that you don’t switch the app. Switching more than twice submits the test.</b>
                  </li>
                  <li>
                    <b>Please put your phone in Do-Not-Disturb (DND) mode while taking the test.</b>
                  </li>
                    <li>
                      Total Duration of test is allocated by the faculty and is shown on the top of the test screen.
                </li>
                    <li>
                      The Test should be taken within the time of expiry as mentioned by the faculty.
                </li>
                    <li>
                      The test will be Multiple choice questions with a single correct answer.
                </li>
                    <li>
                      There is no negative marking for the incorrectly answered questions.
                </li>
                    <li>
                      One point will be awarded for each correctly answered question.
                </li>
                    <li>
                      The Test will be auto-submitted once the allocated duration of the test completes.
                </li>
                    <li>
                      There will be four level of questions: Remembering, Understanding, Applying and Analyzing.
                </li>
                    <li>
                      The results for the test will auto-appear once the test gets expired.
                </li>
                    <li>
                      The detailed report for the test and correct answers will be shown in the results.
                </li>
                    <li>WARNING:  You are not allowed to take any screenshots during the test, this may effect your scores. </li>
                    <li>
                      The scores generated in the test will have a huge impact on your performance analytics.
                </li>
                  </ul>
                </div>
              </Flex>
            </TestDescriptionWrapper>

            <div style={{backgroundColor: '#f6f6f6',position: 'fixed', bottom: '0', background: '#f6f6f6', overflowY: 'hidden', width: '100%', margin: '0 auto' }}>
              <Flex direction="row" justifyBetween alignCenter style={{  padding: '0 20%', paddingBottom: '10px'}}>
                {/* <Link to={results ? `/testResults/${tid}/0` : `/test/${tid}/0`}> */}
                  {/* <button onClick={(results)=>logAmplitudeEvent(results)} className='startButton'>{results ? `Show answers` : `START TEST`}</button> */}
                  <div>
                    <button className='startButton' onClick={()=>this.openModal()} >{results ? `Show answers` : `START TEST`}</button>
                  </div>
                {/* </Link> */}
                {/* <Button small onClick={() => callbackToNative('done')} background="white" color="gray">Close </Button> */}
              </Flex>
            </div>
          </div>
          :
          <h3>Something went wrong try again later</h3>
        }

      </Flex>
      <style jsx='true' scoped>{`
      .startButton{
          padding: 0.5em 2.5em;
          font-size: 16px;
          font-weight: bold;
          border-radius: 16px;
          background: 
            linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) padding-box, 
            linear-gradient(to right bottom, #7175E0 0%, #4D50CB 32.912%, #E25BC8 100%) border-box;
          color: white;
          border: none;
          cursor: pointer;
          &:focus{
            outline:0;
          }
      }
      
      `}

      </style>
    </div>

    )
  }
}

export default TestDescription;
